export { default } from './WhyBuy';
